import { observer } from 'mobx-react-lite'
import { StudentAssignmentStep1 } from './StudentAssignmentStep1'
import { StudentAssignmentStep2 } from './StudentAssignmentStep2'
import { StudentAssignmentStep3 } from './StudentAssignmentStep3/StudentAssignmentStep3'
import { useStudentAssignmentCubit } from 'hooks/cubits/studentAssignment'
import classNames from 'classnames'
import { useTranslationTyped } from 'i18n/i18n'

export const StudentAssignmentStepsLoading = () => {
  return (
    <div className="flex h-full w-full flex-grow flex-col items-center justify-start overflow-auto rounded-3xl bg-core-tertiary lg:w-auto">
      <div className="h-full max-h-full">
        <div className="flex h-full flex-col items-center justify-center overflow-auto">
          Loading...
        </div>
      </div>
    </div>
  )
}

export const StudentAssignmentSteps = observer(
  function StudentAssignmentSteps() {
    const cubit = useStudentAssignmentCubit()
    const { tt } = useTranslationTyped()

    const hasPreWorkMaterials = cubit.availableStudentMaterials.some(
      (m) => m.isPreWork
    )
    const hasPreMeetingQuiz = cubit.hasPreWorkQuiz
    const showStep2 = hasPreWorkMaterials || hasPreMeetingQuiz

    return (
      <div
        className={classNames(
          'flex w-full flex-grow flex-col items-center justify-between rounded-3xl bg-core-tertiary p-3 md:h-full md:overflow-auto',
          {
            'space-y-3': showStep2,
          }
        )}
      >
        <StudentAssignmentStep1
          role="group"
          aria-label={tt.student_assignment.step_1()}
          className={classNames(
            'flex w-full flex-1 flex-col items-center justify-center py-5 text-center',
            {
              'mt-1': showStep2,
            }
          )}
        />
        {showStep2 && (
          <>
            <div className="w-[90%] max-w-[90%] border-t border-gray-200 md:w-[500px]" />
            <StudentAssignmentStep2
              role="group"
              aria-label={tt.student_assignment.step_2()}
              className="mt-1 flex flex-1 flex-col items-center justify-center py-5 text-center"
              hasPreMeetingQuiz={hasPreMeetingQuiz}
              hasPreWorkMaterials={hasPreWorkMaterials}
            />
          </>
        )}
        <div className="w-[90%] max-w-[90%] border-t border-gray-200 md:w-[500px]" />
        <StudentAssignmentStep3
          key="step3-stable"
          showStep2Title={!showStep2}
          role="group"
          aria-label={
            showStep2
              ? tt.student_assignment.step_3()
              : tt.student_assignment.step_2()
          }
          className="flex flex-1 flex-col items-center justify-center pb-8 pt-4 text-center"
        />
      </div>
    )
  }
)
